module.exports = __webpack_public_path__ + "static/img/order.0dea48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order.png
// module id = x5oV
// module chunks = 3